// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about_wrapper__iH__m","about":"about_about__LAfKa","bio":"about_bio__uJxNH","title":"about_title__aB_cf","image":"about_image__CcRmg","pre":"about_pre__ZoeIB"};